import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";
import { getHelpArticle, createHelpArticleView } from "../../services/helpApi";

const useHelpArticle = (slug) => {
  const [loading, setLoading] = useState(true);
  const [article, setArticle] = useState(null);

  useEffect(() => {
    let isMounted = true;
    if (!slug) {
      setLoading(false);
      return;
    }

    const fetchArticle = async () => {
      setLoading(true);
      try {
        const { data } = await getHelpArticle(slug);
        if (isMounted) {
          setArticle(data);
        }

        // Registrar visualização
        if (data?.id) {
          await createHelpArticleView(data.id);
        }

        if (isMounted) {
          setLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          setLoading(false);
          toastError(err);
        }
      }
    };

    fetchArticle();
    return () => {
      isMounted = false;
    };
  }, [slug]);

  return { article, loading };
};

export default useHelpArticle;
